import './styles.css';

const CheckBox = (props) => {
  return <div className="custom-checkbox">
    <input type="checkbox" id={props.id} name={props.name} value={props.value} onChange={props.onChange}/>
    <label for={props.name}>{props.isRequired ? <span>*</span> : null} {props.label}</label>
  </div>
};

export default CheckBox;